export class DeleteCreditRequest {
    CreditID: number;
    Note: string;
}
